import { LEVEL_WIDTH, TileData, TileType } from "./types";
import { tileKey, type EnemySpawn, type LevelData } from "./level";

// World 4-1: Long overworld with many gaps and koopas
export function buildLevel4_1(): LevelData {
  const tiles = new Map<string, TileData>();
  const groundTop = -1;
  const groundDepth = 2;

  const pits: Array<[number, number]> = [
    [14, 16],
    [28, 30],
    [44, 46],
    [58, 60],
    [72, 74],
    [86, 88],
    [100, 102],
    [114, 116],
    [128, 130],
    [142, 144],
    [156, 158],
    [170, 172]
  ];

  const setTile = (x: number, y: number, type: TileType, payload?: TileData["payload"], flower?: boolean): void => {
    tiles.set(tileKey(x, y), { type, payload, broken: false, bump: 0, flower: flower || undefined });
  };

  const isPit = (x: number): boolean => pits.some(([a, b]) => x >= a && x <= b);

  for (let x = 0; x < LEVEL_WIDTH; x++) {
    if (isPit(x)) continue;
    for (let dy = 0; dy < groundDepth; dy++) {
      setTile(x, groundTop - dy, TileType.Ground);
    }
  }

  const stair = (x: number, h: number): void => {
    for (let dy = 0; dy < h; dy++) setTile(x, groundTop + 1 + dy, TileType.Block);
  };

  setTile(8, 4, TileType.Question, { kind: "mushroom" });

  const pipes: Array<[number, number]> = [
    [20, 2],
    [34, 3],
    [50, 4],
    [64, 2],
    [78, 3],
    [92, 4],
    [106, 2],
    [120, 3],
    [134, 4],
    [148, 2],
    [162, 3],
    [176, 4]
  ];
  for (const [px, h] of pipes) {
    for (let dy = 0; dy < h; dy++) {
      setTile(px, groundTop + 1 + dy, TileType.Pipe);
      setTile(px + 1, groundTop + 1 + dy, TileType.Pipe);
    }
  }

  // brick formations
  for (let x = 22; x <= 26; x++) setTile(x, 4, TileType.Brick);
  setTile(24, 4, TileType.Question, { kind: "coin" });

  for (let x = 36; x <= 40; x++) setTile(x, 4, TileType.Brick);
  setTile(38, 4, TileType.Question, { kind: "mushroom" });

  for (let x = 52; x <= 56; x++) setTile(x, 4, TileType.Brick);
  setTile(54, 4, TileType.Question, { kind: "coin" });

  for (let x = 66; x <= 70; x++) setTile(x, 4, TileType.Brick);
  setTile(68, 4, TileType.Question, { kind: "coin" });

  for (let x = 80; x <= 84; x++) setTile(x, 4, TileType.Brick);
  setTile(82, 4, TileType.Question, { kind: "mushroom" });

  for (let x = 94; x <= 98; x++) setTile(x, 4, TileType.Brick);
  setTile(96, 4, TileType.Question, { kind: "coin" });

  for (let x = 108; x <= 112; x++) setTile(x, 4, TileType.Brick);
  setTile(110, 4, TileType.Question, { kind: "coin" });

  for (let x = 122; x <= 126; x++) setTile(x, 4, TileType.Brick);
  setTile(124, 4, TileType.Question, { kind: "mushroom" });

  for (let x = 136; x <= 140; x++) setTile(x, 4, TileType.Brick);
  setTile(138, 4, TileType.Question, { kind: "coin" });

  for (let x = 150; x <= 154; x++) setTile(x, 4, TileType.Brick);
  setTile(152, 4, TileType.Question, { kind: "coin" });

  for (let x = 164; x <= 168; x++) setTile(x, 4, TileType.Brick);
  setTile(166, 4, TileType.Question, { kind: "mushroom" });

  setTile(180, 4, TileType.Brick);
  setTile(181, 4, TileType.Brick);
  setTile(182, 4, TileType.Brick);

  stair(184, 1);
  stair(185, 2);
  stair(186, 3);
  stair(187, 4);
  stair(188, 4);
  stair(189, 4);
  stair(190, 3);
  stair(191, 2);
  stair(192, 1);

  const flagX = 198;
  for (let y = groundTop + 1; y <= 21; y++) setTile(flagX, y, TileType.Pole);
  setTile(flagX, 22, TileType.Block);

  const castleX = 202;

  const enemies: EnemySpawn[] = [
    { kind: "goomba", x: 10 },
    { kind: "koopa", x: 18 },
    { kind: "goomba", x: 24 },
    { kind: "koopa", x: 32 },
    { kind: "goomba", x: 40 },
    { kind: "goomba", x: 48 },
    { kind: "koopa", x: 56 },
    { kind: "goomba", x: 64 },
    { kind: "koopa", x: 72 },
    { kind: "goomba", x: 80 },
    { kind: "goomba", x: 88 },
    { kind: "koopa", x: 96 },
    { kind: "goomba", x: 104 },
    { kind: "koopa", x: 112 },
    { kind: "goomba", x: 120 },
    { kind: "goomba", x: 128 },
    { kind: "koopa", x: 136 },
    { kind: "goomba", x: 144 },
    { kind: "goomba", x: 152 },
    { kind: "koopa", x: 160 },
    { kind: "goomba", x: 168 },
    { kind: "goomba", x: 176 },
    { kind: "koopa", x: 184 }
  ];

  return { tiles, enemies, enterablePipes: [], flagX, castleX, width: LEVEL_WIDTH, groundY: 0 };
}
